import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import Routes from "./navigation/routes";
import { AuthProvider } from "./providers/AuthProvider";
import { UsersDataProvider } from "./providers/UsersDataProvider";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./App.css"
import { UsersProvider } from "./providers/Users";
import { SidebarProvider } from "./providers/SidebarProvider";
import { LanguageProvider } from './providers/LanguageProvider';


export default () => {
  return (
    <AuthProvider>
    <LanguageProvider>
      <UsersDataProvider>
        <UsersProvider>
          <SidebarProvider>
        <Routes />
        </SidebarProvider>
        </UsersProvider>
      </UsersDataProvider>
      </LanguageProvider>
    </AuthProvider>
  );
};
